
export const INITIAL_AI_SUGGESTIONS = {
  requestType: 'Suggest target mappings',
  minConfidence: 0.9,
  maxCandidates: 3,
};